import React from 'react';
import { Tooltip,VariantType,IPosition, PlacesType} from 'react-tooltip';

interface ReactTooltipProps {
  id: string;
  styles?: string;
  children: JSX.Element
  variant?: VariantType
  position?:IPosition
  place?:PlacesType
}

const ReactToolTip: React.FC<ReactTooltipProps> = ({ id, styles,children, variant,position, place, ...rest }) => {
  return <Tooltip 
    style={{"padding":"0px"}}
    opacity="1"
    arrowColor="white"
    variant={variant} position={position} place={place} id={id}  {...rest}>
    <div className={`p-4 max-w-[300px] overflow-hidden whitespace-normal rounded  shadow-md `}>
    {children}

    </div>
  </Tooltip>;
};

export { ReactToolTip };
